import { render } from "./SimplePage.vue?vue&type=template&id=3bd9f06b"
import script from "./SimplePage.vue?vue&type=script&lang=js"
export * from "./SimplePage.vue?vue&type=script&lang=js"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__